import { axiosAssetDashApi} from './api';

export const getCurrentUser = async () => {
  return await axiosAssetDashApi.get('/api/api_v4/users/me');
};